import i18n from "src/i18n/config";
import TimeService from "src/services/timeService/timeService";
import { z } from "zod";

import { ScheduleType } from "../CreateRolloutSidePanel.utils";

export const ScheduleDateFormat = "dd/MM/yyyy HH:mm";

const scheduleMinAdvanceHours = 24;

export function isWindowStartValid(date: Date | null | undefined): boolean {
    if (!date) {
        return false;
    }
    const minWindowStart = TimeService.getNow().plus({ hours: scheduleMinAdvanceHours });
    return TimeService.getFromMillis(date.getTime()) > minWindowStart;
}

export function isWindowEndValid(start: Date | null | undefined, end: Date | null | undefined): boolean {
    if (!start || !end) {
        return false;
    }
    return TimeService.getFromMillis(end.getTime()) > TimeService.getFromMillis(start.getTime());
}

export const scheduleValidationSchema = z
    .object({
        scheduleType: z.nativeEnum(ScheduleType),
        windowStart: z.date().nullable().optional(),
        windowEnd: z.date().nullable().optional(),
    })
    .superRefine((data, ctx) => {
        if (data.scheduleType !== ScheduleType.TimeWindow) {
            return;
        }
        if (!isWindowStartValid(data.windowStart)) {
            ctx.addIssue({
                code: "custom",
                message: i18n.t("sidepanels:rolloutPanel.schedule.timeWindow.errorStartTooSoon"),
                path: ["windowStart"],
            });
        }
        if (!isWindowEndValid(data.windowStart, data.windowEnd)) {
            ctx.addIssue({
                code: "custom",
                message: i18n.t("sidepanels:rolloutPanel.schedule.timeWindow.errorEndBeforeStart"),
                path: ["windowEnd"],
            });
        }
    });
